/**
 * Canonical paid-amount extractor for a single invoice.
 *
 * Every surface that displays or aggregates a "paid" figure MUST call
 * this function. Using status-based attribution (full amount when
 * status is "paid") is the bug this helper prevents. The backend
 * equivalent is read_money_or_zero(inv, "amount_paid").
 *
 * Surfaces differ ONLY by date-bucketing basis (due_date vs issue_date),
 * never by how they compute the paid amount for a single invoice.
 */
export function invoicePaidAmount(inv) {
  return inv?.amount_paid ?? 0;
}
